import React from "react";
import { useTranslation } from "react-i18next";
import { ShippingManager } from "../features/shipping/Manager";
import { withRestaurantId } from "../shared/components/layout";

const ShippingManagerWithId = withRestaurantId(ShippingManager);

const ShippingManagementPage: React.FC = () => {
  const { t } = useTranslation();

  return <ShippingManagerWithId />;
};

export default ShippingManagementPage;
